
import { totalMinutes, fromMinutes } from "../../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { anonRecord_type, unit_type, lambda_type, int32_type, record_type, bool_type, option_type, list_type, class_type, float64_type, union_type, string_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { bind, map, ofNullable } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { DateTimeRange, DateTimeRange_$reflection, SensorMetaData_$reflection, PortWindWeather_$reflection, SensorId_$reflection, SensorId } from "../../StenaWeather.Domain/PortWind.js";
import { join, printf, toText, interpolate } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { Convert_fromJson, Convert_serialize } from "../../fable_modules/Fable.SimpleJson.3.24.0/Json.Converter.fs.js";
import { createTypeInfo } from "../../fable_modules/Fable.SimpleJson.3.24.0/TypeInfo.Converter.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.5.0.0/Result.js";
import { SimpleJson_tryParse } from "../../fable_modules/Fable.SimpleJson.3.24.0/SimpleJson.fs.js";
import { int32ToString, equals, createObj, comparePrimitives, round, compare, Exception } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { empty as empty_1, ofList, toList } from "../../fable_modules/fable-library-js.5.0.0/Set.js";
import { Point_$reflection } from "../../StenaWeather.Domain/Forecast.js";
import { filter, ofArray, replicate, singleton as singleton_1, map as map_1, empty } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { ofList as ofList_1, empty as empty_2 } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { knotsToMs, msToKnots } from "../../StenaWeather.Domain/Units.js";
import { choose, isEmpty, empty as empty_3, singleton, append, delay, toList as toList_1 } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { createElement } from "react";
import { ColumnModule_View } from "../../Components/StenaWebUI/Core/Column.js";
import { RowModule_View } from "../../Components/StenaWebUI/Core/Row.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { SpaceModule_View } from "../../Components/StenaWebUI/Core/Space.js";
import { Color_$reflection, Color, theme } from "../../Theme.js";
import { IconModule_View } from "../../Components/StenaWebUI/Icons/Icon.js";
import { faMoon, faWater, faWind, faLongArrowAltUp, faTornado, faFan, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { style_outline_none } from "../../Feliz.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { map as map_2 } from "../../fable_modules/fable-library-js.5.0.0/Array.js";

export const autoReloadPeriod = fromMinutes(1);

export class WeatherValueId extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["WeatherValueId"];
    }
}

export function WeatherValueId_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.WeatherValueId", [], WeatherValueId, () => [[["Item", string_type]]]);
}

export class ThresholdLines extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["ThresholdLines"];
    }
}

export function ThresholdLines_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.ThresholdLines", [], ThresholdLines, () => [[["Item", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [WeatherValueId_$reflection(), float64_type])]]]);
}

export function ThresholdLines__get_Value(this$) {
    return this$.fields[0];
}

export function LocalStorage_set(key, value) {
    localStorage.setItem(key, value);
}

export function LocalStorage_get(key) {
    return ofNullable(localStorage.getItem(key));
}

export function LocalStorage_setSensorId(_arg) {
    LocalStorage_set("weatherservice.portwind.sensorid", _arg.fields[0]);
}

export function LocalStorage_getSensorId() {
    return map((Item) => (new SensorId(Item)), LocalStorage_get("weatherservice.portwind.sensorid"));
}

export function LocalStorage_setIsMetric(x) {
    LocalStorage_set("weatherservice.portwind.ismetric", `${interpolate("%b%P()", [x])}`);
}

export function LocalStorage_getIsMetric() {
    return map((_arg) => {
        if (_arg === "false") {
            return false;
        }
        else {
            return true;
        }
    }, LocalStorage_get("weatherservice.portwind.ismetric"));
}

export function LocalStorage_setThreshold(_arg) {
    LocalStorage_set("weatherservice.portwind.threshold", Convert_serialize(_arg.fields[0], createTypeInfo(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [WeatherValueId_$reflection(), float64_type]))));
}

export function LocalStorage_getThreshold() {
    return map((Item) => (new ThresholdLines(Item)), bind((s) => {
        let matchValue;
        let matchValue_1;
        try {
            matchValue_1 = (new FSharpResult$2(0, [(matchValue = SimpleJson_tryParse(s), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(class_type("Microsoft.FSharp.Collections.FSharpMap`2", [WeatherValueId_$reflection(), float64_type]))) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())]));
        }
        catch (ex) {
            matchValue_1 = (new FSharpResult$2(1, [ex.message]));
        }
        if (matchValue_1.tag === 1) {
            return undefined;
        }
        else {
            return matchValue_1.fields[0];
        }
    }, LocalStorage_get("weatherservice.portwind.threshold")));
}

export function LocalStorage_setHiddenWeatherValues(x) {
    LocalStorage_set("weatherservice.portwind.hiddenweathervalues", Convert_serialize(toList(x), createTypeInfo(list_type(WeatherValueId_$reflection()))));
}

export function LocalStorage_getHiddenWeatherValues() {
    return map((elements) => ofList(elements, {
        Compare: (x_1, y) => (compare(x_1, y) | 0),
    }), bind((s) => {
        let matchValue;
        let matchValue_1;
        try {
            matchValue_1 = (new FSharpResult$2(0, [(matchValue = SimpleJson_tryParse(s), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(list_type(WeatherValueId_$reflection()))) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())]));
        }
        catch (ex) {
            matchValue_1 = (new FSharpResult$2(1, [ex.message]));
        }
        if (matchValue_1.tag === 1) {
            return undefined;
        }
        else {
            return matchValue_1.fields[0];
        }
    }, LocalStorage_get("weatherservice.portwind.hiddenweathervalues")));
}

export function LocalStorage_setHiddenSensors(x) {
    LocalStorage_set("weatherservice.portwind.hiddensensors", Convert_serialize(toList(x), createTypeInfo(list_type(SensorId_$reflection()))));
}

export function LocalStorage_getHiddenSensors() {
    return map((elements) => ofList(elements, {
        Compare: (x_1, y) => (compare(x_1, y) | 0),
    }), bind((s) => {
        let matchValue;
        let matchValue_1;
        try {
            matchValue_1 = (new FSharpResult$2(0, [(matchValue = SimpleJson_tryParse(s), (matchValue != null) ? Convert_fromJson(matchValue, createTypeInfo(list_type(SensorId_$reflection()))) : (() => {
                throw new Exception("Couldn\'t parse the input JSON string because it seems to be invalid");
            })())]));
        }
        catch (ex) {
            matchValue_1 = (new FSharpResult$2(1, [ex.message]));
        }
        if (matchValue_1.tag === 1) {
            return undefined;
        }
        else {
            return matchValue_1.fields[0];
        }
    }, LocalStorage_get("weatherservice.portwind.hiddensensors")));
}

export class PortWindData extends Record {
    constructor(Weather, Location, LastUpdated, WindSpeedAverageRange, IsFallbackData) {
        super();
        this.Weather = Weather;
        this.Location = Location;
        this.LastUpdated = LastUpdated;
        this.WindSpeedAverageRange = WindSpeedAverageRange;
        this.IsFallbackData = IsFallbackData;
    }
}

export function PortWindData_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.PortWindData", [], PortWindData, () => [["Weather", option_type(PortWindWeather_$reflection())], ["Location", option_type(Point_$reflection())], ["LastUpdated", class_type("System.DateTimeOffset")], ["WindSpeedAverageRange", option_type(class_type("System.TimeSpan"))], ["IsFallbackData", bool_type]]);
}

export class MapCenterAndZoom extends Union {
    constructor(Item1, Item2) {
        super();
        this.tag = 0;
        this.fields = [Item1, Item2];
    }
    cases() {
        return ["MapCenterAndZoom"];
    }
}

export function MapCenterAndZoom_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.MapCenterAndZoom", [], MapCenterAndZoom, () => [[["Item1", Point_$reflection()], ["Item2", int32_type]]]);
}

export class ReportGraphView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Chart", "Table"];
    }
}

export function ReportGraphView_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.ReportGraphView", [], ReportGraphView, () => [[], []]);
}

export class MainView extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Dashboard", "TrendGraph", "ReportGraph", "Map"];
    }
}

export function MainView_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.MainView", [], MainView, () => [[], [], [["Item", ReportGraphView_$reflection()]], [["centerAndZoom", option_type(MapCenterAndZoom_$reflection())]]]);
}

export class State extends Record {
    constructor(Sensors, SelectedSensor, DateTimeRange, HiddenWeatherValues, HiddenSensors, Weather, WeatherHistory, UnitsIsMetric, MainView, ClientSessionId, ThresholdLines, IsRefreshing, PollGeneration) {
        super();
        this.Sensors = Sensors;
        this.SelectedSensor = SelectedSensor;
        this.DateTimeRange = DateTimeRange;
        this.HiddenWeatherValues = HiddenWeatherValues;
        this.HiddenSensors = HiddenSensors;
        this.Weather = Weather;
        this.WeatherHistory = WeatherHistory;
        this.UnitsIsMetric = UnitsIsMetric;
        this.MainView = MainView;
        this.ClientSessionId = ClientSessionId;
        this.ThresholdLines = ThresholdLines;
        this.IsRefreshing = IsRefreshing;
        this.PollGeneration = PollGeneration;
    }
}

export function State_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.State", [], State, () => [["Sensors", list_type(SensorMetaData_$reflection())], ["SelectedSensor", option_type(SensorId_$reflection())], ["DateTimeRange", DateTimeRange_$reflection()], ["HiddenWeatherValues", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [WeatherValueId_$reflection()])], ["HiddenSensors", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [SensorId_$reflection()])], ["Weather", option_type(PortWindData_$reflection())], ["WeatherHistory", list_type(PortWindWeather_$reflection())], ["UnitsIsMetric", bool_type], ["MainView", MainView_$reflection()], ["ClientSessionId", class_type("System.Guid")], ["ThresholdLines", ThresholdLines_$reflection()], ["IsRefreshing", bool_type], ["PollGeneration", class_type("System.Guid")]]);
}

export function State_get_Empty() {
    return new State(empty(), undefined, new DateTimeRange(undefined, undefined), empty_1({
        Compare: (x, y) => (compare(x, y) | 0),
    }), empty_1({
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    }), undefined, empty(), true, new MainView(0, []), "00000000-0000-0000-0000-000000000000", new ThresholdLines(empty_2({
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    })), false, "00000000-0000-0000-0000-000000000000");
}

export function State__get_UnitText(state) {
    if (state.UnitsIsMetric) {
        return "m/s";
    }
    else {
        return "kn";
    }
}

export function State__get_UnitValue(state) {
    const f1_1 = state.UnitsIsMetric ? ((value) => value) : (msToKnots);
    return (arg_1) => round(f1_1(arg_1), 3);
}

export function State__get_UnitValueToMs(state) {
    if (state.UnitsIsMetric) {
        return (y) => (1 * y);
    }
    else {
        return (arg) => knotsToMs(1 * arg);
    }
}

export function ViewHelpers_mkColumnWith(p, x) {
    const p_1_1 = ofList_1(map_1((value) => value, toList_1(delay(() => append(p, delay(() => singleton(["children", x])))))), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
    return createElement(ColumnModule_View, {
        p: p_1_1,
    });
}

export function ViewHelpers_mkColumn(x) {
    const p_1_1 = ofList_1(map_1((value) => value, singleton_1(["children", x])), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
    return createElement(ColumnModule_View, {
        p: p_1_1,
    });
}

export function ViewHelpers_mkRowWith(p, x) {
    const p_1_1 = ofList_1(map_1((value) => value, toList_1(delay(() => append(p, delay(() => singleton(["children", x])))))), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
    return createElement(RowModule_View, {
        p: p_1_1,
    });
}

export function ViewHelpers_mkRow(x) {
    const p_1_1 = ofList_1(map_1((value) => value, singleton_1(["children", x])), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    });
    return createElement(RowModule_View, {
        p: p_1_1,
    });
}

export function ViewHelpers_divWith(p, x) {
    return HtmlHelper_createElement("div", toList_1(delay(() => append(p, delay(() => singleton(["children", x]))))));
}

export function ViewHelpers_spanWith(p, x) {
    return HtmlHelper_createElement("span", toList_1(delay(() => append(p, delay(() => singleton(["children", x]))))));
}

export function ViewHelpers_spaceN(n) {
    let p_1_1;
    return replicate(n, (p_1_1 = ofList_1(map_1((value) => value, empty()), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), createElement(SpaceModule_View, {
        p: p_1_1,
    })));
}

/**
 * Orange warning row shown when the values come from the fallback storage
 * instead of the live time series.
 */
export function ViewHelpers_fallbackDataBanner(message) {
    let t_1;
    return ViewHelpers_divWith([["style", {
        display: "flex",
        alignItems: "center",
        backgroundColor: theme(new Color(17, [])),
        color: theme(new Color(0, [])),
        padding: ((8 + "px") + " ") + (12 + "px"),
        marginBottom: 8 + "px",
        borderRadius: 4 + "px",
    }]], ofArray([ViewHelpers_spanWith([["style", {
        display: "flex",
        marginRight: 8 + "px",
    }]], singleton_1(IconModule_View(ofList_1(map_1((value_18) => value_18, ofArray([["size", 16], (t_1 = faExclamationTriangle, ["icon", t_1]), ["color", theme(new Color(20, []))]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    })))), createElement("span", defaultOf(), message)]));
}

export function ViewHelpers_mkTextWith(f, color, size, p, s) {
    return f(singleton_1(["style", createObj(toList_1(delay(() => append(singleton(["color", color]), delay(() => append(singleton(["fontSize", size]), delay(() => p)))))))]), singleton_1(s));
}

export function ViewHelpers_mkTextSizeUnit(color, size, p, s) {
    return ViewHelpers_mkTextWith(ViewHelpers_spanWith, color, size, p, s);
}

export function ViewHelpers_mkText(color, size, p, s) {
    return ViewHelpers_mkTextWith(ViewHelpers_spanWith, color, size + "vmin", p, s);
}

export function ViewHelpers_mkTextMulti(padding, color, xs) {
    return ViewHelpers_spanWith([], map_1((tupledArg) => ViewHelpers_mkText(color, tupledArg[1], [["paddingRight", padding]], tupledArg[0]), xs));
}

export function ViewHelpers_leftRightColumns(isSmall, width, left, right) {
    if (isSmall) {
        return ViewHelpers_mkColumn(toList_1(delay(() => append(singleton(ViewHelpers_mkRow(singleton_1(ViewHelpers_mkColumn(left)))), delay(() => append(ViewHelpers_spaceN(1), delay(() => singleton(ViewHelpers_mkRow(singleton_1(ViewHelpers_mkColumn(right)))))))))));
    }
    else {
        return ViewHelpers_mkRow(singleton_1(ViewHelpers_mkColumnWith([["width", width]], singleton_1(ViewHelpers_mkRowWith([["justifyContent", "space-between"]], ofArray([ViewHelpers_mkColumn(left), ViewHelpers_mkColumnWith([["justifyContent", "flex-end"]], right)]))))));
    }
}

export function ViewHelpers_threeColumns(width, left, middle, right) {
    return ViewHelpers_mkRow(singleton_1(ViewHelpers_mkColumnWith([["width", width]], singleton_1(ViewHelpers_mkRowWith([["justifyContent", "space-between"]], ofArray([ViewHelpers_mkColumn(left), ViewHelpers_mkColumnWith([["justifyContent", "center"]], middle), ViewHelpers_mkColumnWith([["justifyContent", "flex-end"]], right)]))))));
}

export function ViewHelpers_styledDropdown(title, options, selectedValue, onValueChange) {
    return HtmlHelper_createElement("select", ofArray([["style", createObj(ofArray([["fontSize", 2 + "vmin"], ["color", theme(new Color(4, []))], ["backgroundColor", theme(new Color(5, []))], ["borderRadius", 0.5 + "vmin"], ["borderWidth", 0], style_outline_none, ["borderRight", ((((1 + "vmin") + " ") + "solid") + " ") + theme(new Color(5, []))], ["marginRight", 0.5 + "vmin"], ["padding", 0.5 + "vmin"]]))], ["title", title], ["onChange", (ev) => {
        onValueChange(ev.target.value);
    }], ["children", map_1((tupledArg) => {
        const value_19 = tupledArg[1];
        return HtmlHelper_createElement("option", toList_1(delay(() => append(singleton(["children", singleton_1(tupledArg[0])]), delay(() => append(singleton(["value", value_19]), delay(() => (equals(selectedValue, value_19) ? singleton(["selected", true]) : empty_3()))))))));
    }, options)]]));
}

export function ViewHelpers_styledGroupedDropdown(title, groups, selectedValue, onValueChange) {
    return HtmlHelper_createElement("select", ofArray([["style", createObj(ofArray([["fontSize", 2 + "vmin"], ["color", theme(new Color(4, []))], ["backgroundColor", theme(new Color(5, []))], ["borderRadius", 0.5 + "vmin"], ["borderWidth", 0], style_outline_none, ["borderRight", ((((1 + "vmin") + " ") + "solid") + " ") + theme(new Color(5, []))], ["marginRight", 0.5 + "vmin"], ["padding", 0.5 + "vmin"]]))], ["title", title], ["onChange", (ev) => {
        onValueChange(ev.target.value);
    }], ["children", map_1((tupledArg) => HtmlHelper_createElement("optgroup", ofArray([["label", tupledArg[0]], ["children", map_1((tupledArg_1) => {
        const value_21 = tupledArg_1[1];
        return HtmlHelper_createElement("option", toList_1(delay(() => append(singleton(["children", singleton_1(tupledArg_1[0])]), delay(() => append(singleton(["value", value_21]), delay(() => (equals(selectedValue, value_21) ? singleton(["selected", true]) : empty_3()))))))));
    }, tupledArg[1])]])), groups)]]));
}

export function ViewHelpers_timeWindowDropdown(options, defaultValue, onValueChange) {
    const selectedValue = defaultValue.toString();
    return ViewHelpers_styledDropdown("Select time window", map_1((h) => [toText(printf("%gh"))(h), h.toString()], options), selectedValue, (ev) => {
        onValueChange(parse(ev));
    });
}

export class ColorHsl extends Union {
    constructor(hue, saturation, lightness) {
        super();
        this.tag = 0;
        this.fields = [hue, saturation, lightness];
    }
    cases() {
        return ["ColorHsl"];
    }
}

export function ColorHsl_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.ColorHsl", [], ColorHsl, () => [[["hue", int32_type], ["saturation", int32_type], ["lightness", int32_type]]]);
}

export function ColorHslModule_toCssString(_arg) {
    return toText(printf("hsl(%d, %d%%, %d%%)"))(_arg.fields[0])(_arg.fields[1])(_arg.fields[2]);
}

export class WeatherValue_TrendType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Line", "Area"];
    }
}

export function WeatherValue_TrendType_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.WeatherValue.TrendType", [], WeatherValue_TrendType, () => [[], []]);
}

export class WeatherValue_Unit extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["MsOrKnots", "Degree", "Meter"];
    }
}

export function WeatherValue_Unit_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.WeatherValue.Unit", [], WeatherValue_Unit, () => [[], [], []]);
}

export class WeatherValue_Definition extends Record {
    constructor(Id, Label, ChartName, ValueFormat, Unit, Icon, ChartType, ChartColor, ChartColorOverride, GetValue) {
        super();
        this.Id = Id;
        this.Label = Label;
        this.ChartName = ChartName;
        this.ValueFormat = ValueFormat;
        this.Unit = Unit;
        this.Icon = Icon;
        this.ChartType = ChartType;
        this.ChartColor = ChartColor;
        this.ChartColorOverride = ChartColorOverride;
        this.GetValue = GetValue;
    }
}

export function WeatherValue_Definition_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.WeatherValue.Definition", [], WeatherValue_Definition, () => [["Id", WeatherValueId_$reflection()], ["Label", string_type], ["ChartName", string_type], ["ValueFormat", string_type], ["Unit", WeatherValue_Unit_$reflection()], ["Icon", string_type], ["ChartType", WeatherValue_TrendType_$reflection()], ["ChartColor", Color_$reflection()], ["ChartColorOverride", option_type(ColorHsl_$reflection())], ["GetValue", lambda_type(State_$reflection(), lambda_type(PortWindWeather_$reflection(), option_type(float64_type)))]]);
}

export class WeatherValue_WeatherBox extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["WeatherValue", "WeatherDirection", "TrendChart", "MapBox", "RotatingDirectionSvg"];
    }
}

export function WeatherValue_WeatherBox_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.WeatherValue.WeatherBox", [], WeatherValue_WeatherBox, () => [[["Item", WeatherValue_Definition_$reflection()]], [["Item", WeatherValue_Definition_$reflection()]], [["Item", anonRecord_type(["Label", string_type], ["OnClick", lambda_type(unit_type, unit_type)])]], [["Item", anonRecord_type(["Label", string_type], ["Location", Point_$reflection()], ["SubLabel", string_type])]], [["Item", anonRecord_type(["Flip", bool_type], ["Label", string_type], ["Svg", class_type("Fable.React.ReactElement", undefined)], ["SvgArrow", class_type("Fable.React.ReactElement", undefined)], ["SvgTransform", list_type(class_type("Feliz.ISvgAttribute"))], ["WholeSvgTransform", list_type(class_type("Feliz.ISvgAttribute"))])]]]);
}

const WeatherValue_defaultValues = ofArray([new WeatherValue_Definition(new WeatherValueId("WindSpeed"), "Actual", "Wind", "0.0", new WeatherValue_Unit(0, []), faFan, new WeatherValue_TrendType(0, []), new Color(9, []), undefined, (state, point) => map(State__get_UnitValue(state), point.WindSpeed)), new WeatherValue_Definition(new WeatherValueId("GustWindSpeed"), "Gust wind", "Gust wind", "0.0", new WeatherValue_Unit(0, []), faTornado, new WeatherValue_TrendType(0, []), new Color(10, []), undefined, (state_1, point_1) => map(State__get_UnitValue(state_1), point_1.GustWindSpeed)), new WeatherValue_Definition(new WeatherValueId("MaxGustWindSpeed"), "Max gust wind", "Max gust wind", "0.0", new WeatherValue_Unit(0, []), faTornado, new WeatherValue_TrendType(0, []), new Color(10, []), undefined, (state_2, point_2) => map(State__get_UnitValue(state_2), point_2.MaxGustWindSpeed)), new WeatherValue_Definition(new WeatherValueId("WindDirection"), "Wind direction", "Direction", "000", new WeatherValue_Unit(1, []), faLongArrowAltUp, new WeatherValue_TrendType(0, []), new Color(12, []), undefined, (_arg, point_3) => map((value) => value, point_3.WindDirection)), new WeatherValue_Definition(new WeatherValueId("WindSpeedAverage"), "Average", "Average wind", "0.0", new WeatherValue_Unit(0, []), faWind, new WeatherValue_TrendType(1, []), new Color(11, []), undefined, (state_3, point_4) => map(State__get_UnitValue(state_3), point_4.WindSpeedAverage)), new WeatherValue_Definition(new WeatherValueId("WaveHeight"), "Wave height", "Wave height", "0.00", new WeatherValue_Unit(2, []), faWater, new WeatherValue_TrendType(0, []), new Color(15, []), undefined, (_arg_1, point_5) => map((value_1) => value_1, point_5.WaveHeight)), new WeatherValue_Definition(new WeatherValueId("TideHeight"), "Tide height", "Tide height", "0.00", new WeatherValue_Unit(2, []), faMoon, new WeatherValue_TrendType(0, []), new Color(13, []), undefined, (_arg_2, point_6) => map((value_2) => value_2, point_6.TideHeight)), new WeatherValue_Definition(new WeatherValueId("TidalFlowSpeed"), "Tidal flow speed", "Tidal flow speed", "0.00", new WeatherValue_Unit(0, []), faMoon, new WeatherValue_TrendType(0, []), new Color(14, []), undefined, (state_4, point_7) => map(State__get_UnitValue(state_4), point_7.TidalFlowSpeed))]);

export function WeatherValue_values(state) {
    return map_1((d) => {
        const matchValue = bind((_arg) => _arg.WindSpeedAverageRange, state.Weather);
        let matchResult, t;
        if (matchValue != null) {
            if (d.Id.fields[0] === "WindSpeedAverage") {
                matchResult = 0;
                t = matchValue;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                const s = ` (${totalMinutes(t)}min)`;
                return new WeatherValue_Definition(d.Id, d.Label + s, d.ChartName + s, d.ValueFormat, d.Unit, d.Icon, d.ChartType, d.ChartColor, d.ChartColorOverride, d.GetValue);
            }
            default:
                return d;
        }
    }, WeatherValue_defaultValues);
}

export function WeatherValue_valuesNotEmpty(state) {
    return filter((d) => !isEmpty(choose((x) => d.GetValue(state, x), state.WeatherHistory)), WeatherValue_values(state));
}

export class ThresholdLineDefinition extends Record {
    constructor(WeatherValueId, DashArray, ModalLabel) {
        super();
        this.WeatherValueId = WeatherValueId;
        this.DashArray = DashArray;
        this.ModalLabel = ModalLabel;
    }
}

export function ThresholdLineDefinition_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.ThresholdLineDefinition", [], ThresholdLineDefinition, () => [["WeatherValueId", WeatherValueId_$reflection()], ["DashArray", string_type], ["ModalLabel", string_type]]);
}

export const thresholdLineDefinitions = ofArray([new ThresholdLineDefinition(new WeatherValueId("WindSpeed"), ["strokeDasharray", join(" ", map_2(int32ToString, new Int32Array([3, 3])))], "Wind Speed"), new ThresholdLineDefinition(new WeatherValueId("GustWindSpeed"), ["strokeDasharray", join(" ", map_2(int32ToString, new Int32Array([2, 5])))], "Gust Wind Speed")]);

export class HeaderConfig extends Record {
    constructor(ShowTitle, SensorSelection, MainViewsEnabled, TimeRangePicker, TimeRangeDropDown, UnitSelection, LastUpdated, Refresh) {
        super();
        this.ShowTitle = ShowTitle;
        this.SensorSelection = SensorSelection;
        this.MainViewsEnabled = MainViewsEnabled;
        this.TimeRangePicker = TimeRangePicker;
        this.TimeRangeDropDown = TimeRangeDropDown;
        this.UnitSelection = UnitSelection;
        this.LastUpdated = LastUpdated;
        this.Refresh = Refresh;
    }
}

export function HeaderConfig_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.HeaderConfig", [], HeaderConfig, () => [["ShowTitle", bool_type], ["SensorSelection", bool_type], ["MainViewsEnabled", lambda_type(MainView_$reflection(), bool_type)], ["TimeRangePicker", bool_type], ["TimeRangeDropDown", bool_type], ["UnitSelection", bool_type], ["LastUpdated", bool_type], ["Refresh", bool_type]]);
}

export const HeaderConfigModule_FullHeader = new HeaderConfig(true, true, (_arg) => true, false, true, true, true, true);

export const HeaderConfigModule_MinimalHeader = new HeaderConfig(true, false, (_arg) => false, false, false, false, false, false);

export const HeaderConfigModule_ReportHeader = new HeaderConfig(true, true, (_arg) => false, true, false, true, false, true);

export const HeaderConfigModule_NoHeader = new HeaderConfig(false, HeaderConfigModule_MinimalHeader.SensorSelection, HeaderConfigModule_MinimalHeader.MainViewsEnabled, HeaderConfigModule_MinimalHeader.TimeRangePicker, HeaderConfigModule_MinimalHeader.TimeRangeDropDown, HeaderConfigModule_MinimalHeader.UnitSelection, HeaderConfigModule_MinimalHeader.LastUpdated, HeaderConfigModule_MinimalHeader.Refresh);

export class ViewConfig extends Record {
    constructor(HeaderConfig, InitialMainView, Title, WeatherBoxFilter, TrendChartValuesFilter, StaleDataThreshold) {
        super();
        this.HeaderConfig = HeaderConfig;
        this.InitialMainView = InitialMainView;
        this.Title = Title;
        this.WeatherBoxFilter = WeatherBoxFilter;
        this.TrendChartValuesFilter = TrendChartValuesFilter;
        this.StaleDataThreshold = StaleDataThreshold;
    }
}

export function ViewConfig_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.Common.ViewConfig", [], ViewConfig, () => [["HeaderConfig", lambda_type(MainView_$reflection(), HeaderConfig_$reflection())], ["InitialMainView", MainView_$reflection()], ["Title", string_type], ["WeatherBoxFilter", lambda_type(WeatherValue_WeatherBox_$reflection(), bool_type)], ["TrendChartValuesFilter", lambda_type(WeatherValue_Definition_$reflection(), bool_type)], ["StaleDataThreshold", option_type(class_type("System.TimeSpan"))]]);
}

export const ViewConfigModule_Default = new ViewConfig((_arg) => {
    switch (_arg.tag) {
        case 2:
            return HeaderConfigModule_ReportHeader;
        case 3: {
            const bind$0040 = HeaderConfigModule_MinimalHeader;
            return new HeaderConfig(bind$0040.ShowTitle, bind$0040.SensorSelection, (_arg_1) => {
                switch (_arg_1.tag) {
                    case 0:
                    case 3:
                        return true;
                    default:
                        return false;
                }
            }, bind$0040.TimeRangePicker, bind$0040.TimeRangeDropDown, bind$0040.UnitSelection, bind$0040.LastUpdated, bind$0040.Refresh);
        }
        default:
            return HeaderConfigModule_FullHeader;
    }
}, new MainView(0, []), "PortWind", (_arg_2) => true, (_arg_3) => true, fromMinutes(20));

export const ViewConfigModule_Report = new ViewConfig(ViewConfigModule_Default.HeaderConfig, new MainView(2, [new ReportGraphView(0, [])]), "PortWind Historic Data Report", ViewConfigModule_Default.WeatherBoxFilter, ViewConfigModule_Default.TrendChartValuesFilter, ViewConfigModule_Default.StaleDataThreshold);

export const ViewConfigModule_Simple = new ViewConfig((_arg) => HeaderConfigModule_NoHeader, ViewConfigModule_Default.InitialMainView, ViewConfigModule_Default.Title, (_arg_1) => {
    let matchResult;
    switch (_arg_1.tag) {
        case 1:
        case 2: {
            matchResult = 0;
            break;
        }
        case 0: {
            switch (_arg_1.fields[0].Id.fields[0]) {
                case "WindSpeed":
                case "WindDirection":
                case "WindSpeedAverage":
                case "GustWindSpeed":
                case "MaxGustWindSpeed":
                case "TideHeight": {
                    matchResult = 0;
                    break;
                }
                default:
                    matchResult = 1;
            }
            break;
        }
        default:
            matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return true;
        default:
            return false;
    }
}, (_arg_2) => {
    switch (_arg_2.Id.fields[0]) {
        case "WindSpeed":
        case "WindSpeedAverage":
            return true;
        default:
            return false;
    }
}, ViewConfigModule_Default.StaleDataThreshold);

